/**
 * Light / dark. DARK IS THE DEFAULT (D25): a control room is dark, and
 * index.html ships `<html class="dark">` so the first paint is already dark.
 * The viewer's choice is a per-browser convenience kept in localStorage
 * (read/write guarded — storage can be absent or throw).
 */
export type Theme = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'acp.theme';

/** The theme to start in: the stored choice if it is one, else dark. */
export function initialTheme(stored: string | null): Theme {
  return stored === 'light' ? 'light' : 'dark';
}

export function otherTheme(theme: Theme): Theme {
  return theme === 'dark' ? 'light' : 'dark';
}

/** Apply to the document root: the `dark` class is what the token palette keys on (globals.css). */
export function applyTheme(root: { readonly classList: { toggle: (name: string, force: boolean) => unknown } }, theme: Theme): void {
  root.classList.toggle('dark', theme === 'dark');
}
